var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5998 2.7002C2.60569 2.7002 1.7998 3.50608 1.7998 4.5002V13.5002C1.7998 14.4943 2.60569 15.3002 3.5998 15.3002H14.3998C15.3939 15.3002 16.1998 14.4943 16.1998 13.5002V4.5002C16.1998 3.50608 15.3939 2.7002 14.3998 2.7002H3.5998ZM14.3998 13.5002H3.5998L7.19979 6.3002L9.89979 11.7002L11.6998 8.1002L14.3998 13.5002Z",
    fill: "#4318FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.80c56c4145544998d21e7539e08c4d54.svg";
export { ForwardRef as ReactComponent };